module.exports = __webpack_public_path__ + "static/media/see_no_darkbleu copy.e66a6c39.svg";